module.exports = __webpack_public_path__ + "static/media/dollar-symbol.11a6c1bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dollar-symbol.png
// module id = 1755
// module chunks = 0